import { render } from "./Categorie.vue?vue&type=template&id=54fa4dfb"
import script from "./Categorie.vue?vue&type=script&lang=js"
export * from "./Categorie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__